import { ImageMultipleOutlineIcon } from './ImageMultipleOutlineIcon';

/**
 * author: Google
 * id BCCF75AE-F73D-4B7A-BDFD-9E767DED0B28
 * name image-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-multiple-outline.svg
 * tags
 * - Photography 
 */
export const ImagesOutlineIcon = ImageMultipleOutlineIcon;
export default ImagesOutlineIcon